
import React, { Fragment, useEffect, useState } from 'react';

import { Row, Table, Button } from 'reactstrap';
//import Button from '@material-ui/core/Button';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import SaveIcon from '@material-ui/icons/Save';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import BlockIcon from '@material-ui/icons/Block';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';

const theme = createMuiTheme({
    palette: {
        primary: {
            light: '#84ffe7',
            main: '#49e0b5',
            dark: '#00ad85',
            contrastText: '#fff',
            height: '10px'
        },
    },
});

const FormFallingRisks = ({ caidas, setCaidas, updateFallingRisk, id_admision, disableFormFalling, setDisableFormFalling, edit_fallingRisk, setEdit_fallingRisk }) => {

    const getRiesgoFallingRisk = () => {
        let valor = 0;
        let riesgo;

        if (caidas.caida_previa === 'Sí')
            valor = valor + 1;

        if (caidas.medicamentos === 'Sí')
            valor = valor + 1;

        if (caidas.def_sensoriales === 'Alteraciones Visuales, Auditivas')
            valor = valor + 1;

        if (caidas.estado_mental === 'Confuso')
            valor = valor + 1;

        if (caidas.deambulacion === 'No')
            valor = valor + 1;

        if (valor >= 3) {
            riesgo = "Alto";
        } else if (valor == 2) {
            riesgo = "Medio";
        } else {
            riesgo = "Bajo";
        }

        //setCaidas({ ...caidas, valor: valor, riesgo: riesgo })
        setCaidas(prevState => { return { ...prevState, valor: valor } });
        setCaidas(prevState => { return { ...prevState, riesgo: riesgo } });

        return riesgo;
    }

    return (
        <div style={{ border: '1px solid #CACDD1', borderRadius: 5, marginTop: 5, marginBottom: 10 }} >
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'initial' }}>
                <div style={{ marginLeft: 10, marginTop: 10 }}>
                    <h4>Riesgo de Caída</h4>
                </div>
                <div>
                    {
                        id_admision !== null && id_admision !== undefined && id_admision !== "" ?
                            edit_fallingRisk == false ?
                                <Tooltip title="Editar Riesgo de Caida">
                                    <IconButton aria-label="upload picture" component="span"
                                        onClick={() => {
                                            setEdit_fallingRisk(true);
                                            setDisableFormFalling(false);
                                        }}>
                                        <EditOutlinedIcon />
                                    </IconButton>
                                </Tooltip> : <>
                                    <Tooltip title="Actualizar Datos">
                                        <IconButton aria-label="upload picture" component="span"
                                            onClick={() => {
                                                updateFallingRisk();
                                            }}>
                                            <SaveIcon />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Cancelar Edición">
                                        <IconButton aria-label="upload picture" component="span"
                                            onClick={() => {
                                                setEdit_fallingRisk(false);
                                                setDisableFormFalling(true);
                                            }}>
                                            <BlockIcon />
                                        </IconButton>
                                    </Tooltip>
                                </>
                            : null
                    }
                </div>
                <div style={{ marginLeft: 'auto', marginTop: '0.5em', marginRight: '1em' }}>
                    <h5>Nivel de Riesgo: {caidas.riesgo}</h5>
                </div>
            </div>
            <Row>
                <div className="form" style={{ flexDirection: 'column' }}>
                    <div className="half">
                        <div>
                            <Table style={{ height: 70, margin: 0 }}>
                                <tbody>
                                    <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                        <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>Caidas previas</td>
                                        <td style={{ padding: 2 }}>

                                            <FormControl component="fieldset" >
                                                <RadioGroup
                                                    aria-label="lblCaidasPrev"
                                                    name="rdCaidasPrev"
                                                    value={caidas.caida_previa}
                                                    onChange={e => {
                                                        //setCaidaCaPr(e.target.value);
                                                        console.log("caida_previa",e.target.value);
                                                        //setCaidas({ ...caidas, caida_previa: e.target.value });
                                                        setCaidas(prevState => { return { ...prevState, caida_previa: e.target.value } });
                                                        getRiesgoFallingRisk();
                                                    }}
                                                >
                                                    <FormControlLabel value="Sí" control={<Radio color="primary" />} disabled={disableFormFalling} label="Sí" />
                                                    <FormControlLabel value="No" control={<Radio color="primary" />} disabled={disableFormFalling} label="No" />

                                                </RadioGroup>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                        <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>El Paciente usa medicamentos, Tranquilizantes, sedantes, diuréticos, antidepresivos</td>
                                        <td style={{ padding: 2 }}>

                                            <FormControl component="fieldset2" >
                                                <RadioGroup
                                                    aria-label="lblMedicamentos"
                                                    name="rdMedicamentos"
                                                    value={caidas.medicamentos}
                                                    onChange={e => {
                                                        //setCaida2CaPr(e.target.value);
                                                        console.log("medicamentos",e.target.value);
                                                        //setCaidas({ ...caidas, medicamentos: e.target.value });
                                                        setCaidas(prevState => { return { ...prevState, medicamentos: e.target.value } });
                                                        getRiesgoFallingRisk();
                                                    }}
                                                >
                                                    <FormControlLabel value="Sí" control={<Radio color="primary" />} disabled={disableFormFalling} label="Sí" />
                                                    <FormControlLabel value="No" control={<Radio color="primary" />} disabled={disableFormFalling} label="No" />

                                                </RadioGroup>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                        <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>Deficits Sensoriales</td>
                                        <td style={{ padding: 2 }}>

                                            <FormControl component="fieldset" >
                                                <RadioGroup
                                                    aria-label="Medicamentos"
                                                    name="medicamentos"
                                                    value={caidas.def_sensoriales}
                                                    onChange={e => {
                                                        //setCaida3CaPr(e.target.value);
                                                        //setCaidas({ ...caidas, def_sensoriales: e.target.value });
                                                        console.log("def_sensoriales",e.target.value);
                                                        setCaidas(prevState => { return { ...prevState, def_sensoriales: e.target.value } });
                                                        getRiesgoFallingRisk();
                                                    }}
                                                >
                                                    <FormControlLabel value="Alteraciones Visuales, Auditivas" control={<Radio color="primary" />} disabled={disableFormFalling} label="Alteraciones Visuales, Auditivas" />
                                                    <FormControlLabel value="Ninguno" control={<Radio color="primary" />} disabled={disableFormFalling} label="Ninguno" />
                                                </RadioGroup>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                        <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>Estado mental</td>
                                        <td style={{ padding: 2 }}>

                                            <FormControl component="fieldset" >
                                                <RadioGroup
                                                    aria-label="Medicamentos"
                                                    name="medicamentos"
                                                    value={caidas.estado_mental}
                                                    onChange={e => {
                                                        //setCaida4CaPr(e.target.value);
                                                        //setCaidas({...caidas, estado_mental: e.target.value });
                                                        console.log("estado_mental",e.target.value);
                                                        setCaidas(prevState => { return { ...prevState, estado_mental: e.target.value } });
                                                        getRiesgoFallingRisk();
                                                    }}
                                                >
                                                    <FormControlLabel value="Orientado" control={<Radio color="primary" />} disabled={disableFormFalling} label="Orientado" />
                                                    <FormControlLabel value="Confuso" control={<Radio color="primary" />} disabled={disableFormFalling} label="Confuso" />
                                                </RadioGroup>
                                            </FormControl>
                                        </td>
                                    </tr>
                                    <tr style={{ lineHeight: 1, borderTop: '1px solid #6c757d' }}>
                                        <td style={{ padding: 9, fontSize: '1rem', fontFamily: "Roboto, Helvetica, Arial, sans-serif", fontWeight: 400 }}>El Paciente deambula normalmente de manera segura y sin ayuda</td>
                                        <td style={{ padding: 2 }}>
                                            <ThemeProvider theme={theme}>

                                                <FormControl component="fieldset" >
                                                    <RadioGroup
                                                        aria-label="Medicamentos"
                                                        name="medicamentos"
                                                        value={caidas.deambulacion}
                                                        onChange={e => {
                                                            //setCaida5CaPr(e.target.value);
                                                            //setCaidas({...caidas, deambulacion: e.target.value });
                                                            console.log("deambulacion",e.target.value);
                                                            setCaidas(prevState => { return { ...prevState, deambulacion: e.target.value } });
                                                            getRiesgoFallingRisk();
                                                        }}
                                                    >
                                                        <FormControlLabel value="Sí" control={<Radio color="primary" />} disabled={disableFormFalling} label="Sí" />
                                                        <FormControlLabel value="No" control={<Radio color="primary" />} disabled={disableFormFalling} label="No" />
                                                    </RadioGroup>

                                                </FormControl>
                                            </ThemeProvider>
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </div>
                    </div>
                </div>
            </Row>
        </div>
    );
};

export default FormFallingRisks;
